import React, { useImperativeHandle, useState, forwardRef, useEffect, useRef } from 'react'
import styled from 'styled-components'

const AbsoluteMenuStyled = styled.div`
  display: ${({ positionX, positionY }) => ((positionX && positionY) ? 'flex' : 'none')};
  position: absolute;
  top: ${({ positionY }) => `${positionY + 50}px` || '0px'};
  left: ${({ positionX }) => `${positionX}px` || '0px'};
  transform: translate(-50%, -50%);
  z-index: 999;
  background: #F9F9F9;
  border: 1px solid #D9D9D9;
  align-items: center;
  justify-content: center;
`

// eslint-disable-next-line react/prop-types
const AbsoluteMenu = ({ positionX, positionY, children }, ref) => {
  const [id, setId] = useState()
  const [isOpen, setIsOpen] = useState(false)
  const wrapperRef = useRef()

  useImperativeHandle(ref, () => ({
    open: (portId) => {
      setIsOpen(true)
      setId(portId)
    },
    close: () => {
      setIsOpen(false)
    },
    getId: () => id
  }))

  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        ref.current.close()
      }
    }

    // Bind the event listener
    document.addEventListener('click', handleClickOutside)
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('click', handleClickOutside)
    }
  }, [wrapperRef])

  return (
    <>
      {
        isOpen && (
          <AbsoluteMenuStyled ref={wrapperRef} positionX={positionX} positionY={positionY}>
            {children}
          </AbsoluteMenuStyled>
        )
      }
    </>
  )
}

export default forwardRef(AbsoluteMenu)
